// Libs
import classNames from 'classnames/bind';
import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { useEffect, useState } from 'react';
// Components, Layouts, Pages
import { ItemKanban } from '~/components/common';
// Others
import { ColumnTypeKanban, IBaseKanban } from '~/utils/interface/common';
// Styles, images, icons
import styles from './SortableItem.module.scss';

type Props<T extends IBaseKanban> = {
  id: UniqueIdentifier;
  data: T;
  columnData?: ColumnTypeKanban<T>;
  renderItem: (data: T, columnData?: ColumnTypeKanban<T>) => React.ReactNode;
  disabled?: boolean;
  index: number;
};

const cx = classNames.bind(styles);

const SortableItem = <T extends IBaseKanban>(props: Props<T>) => {
  //#region Destructuring Props
  const { id, data, renderItem, disabled, columnData, index } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { setNodeRef, listeners, isDragging, isSorting, transform, transition } = useSortable({
    id,
    disabled: disabled,
    data: {
      type: 'item',
    },
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isMounted, setIsMounted] = useState<boolean>(false);
  const mountedWhileDragging = isDragging && !isMounted;
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    const timeout = setTimeout(() => setIsMounted(true), 500);

    return () => clearTimeout(timeout);
  }, []);
  //#endregion Implement Hook

  //#region Handle Function

  //#endregion Handle Function

  return (
    <ItemKanban
      ref={disabled ? undefined : setNodeRef}
      data={data}
      columnData={columnData}
      dragging={isDragging}
      sorting={isSorting}
      index={index}
      transition={transition}
      transform={transform}
      fadeIn={mountedWhileDragging}
      listeners={disabled ? undefined : listeners}
      renderItem={renderItem as (data: IBaseKanban, columnData?: ColumnTypeKanban<IBaseKanban>) => React.ReactNode}
    />
  );
};

export default SortableItem;
